import { Outlet } from "react-router";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";
import { routePaths } from "../../Router/router";
import { useState } from "react";
import ContractBanner from "../../Components/Banners/ContractBanner";
import { Container } from "@mui/material";
import SelectModeSubbarOpener from "../../Components/Banners/SelectModeBanner/opener";
import { ContractAndRightType } from "../../Core/Api/Right/right-api-service";

function ContractsIndex() {
  const [selectedContracts, setSelectedContracts] = useState<ContractAndRightType[]>([]);

  const handleBrowsingSubbarCloseClick = () => {
    setSelectedContracts([]);
  };

  return (
    <DashboardLayout
      sxContent={{ px: 2, pb: 2 }}
      noScroll
      Banner={<ContractBanner contracts={selectedContracts} handleCloseClick={handleBrowsingSubbarCloseClick} />}
    >
      <SelectModeSubbarOpener selectedObjects={selectedContracts.map((v) => v.id)} />

      <Outlet
        context={{
          selectedContracts: selectedContracts,
          setSelectedContracts: setSelectedContracts,
        }}
      />
    </DashboardLayout>
  );
}

export default ContractsIndex;
